import React from "react";
import { Product } from "~/common/Store/models/ProductListing";
import CartAndQuantity, { CartAndQuantityProps } from "./CartAndQuantity";

interface ViewReplacementButtonProps extends CartAndQuantityProps {
  product: Product;
}

export default function ViewReplacementButton({
  product,
  isCompareWithProductBox,
  productListingView,
  undoBtnContainerStyle,
}: ViewReplacementButtonProps) {
  return (
    <CartAndQuantity
      {...{
        isCompareWithProductBox,
        productListingView,
        undoBtnContainerStyle,
      }}
    >
      <a
        href={
          product.productReplacement
            ? product.productReplacement.replacementLink
            : ""
        }
      >
        <button
          type="button"
          className="btn btn-info btn-small btn-replace"
          data-testid="replacementBtn"
        >
          View Replacement
        </button>
      </a>
    </CartAndQuantity>
  );
}
